<template>
  <div class="db_update">
    <div class="update_title">
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
          <g id="form" transform="translate(-1 -0.999)">
            <path id="Path_92389" data-name="Path 92389" d="M51,12.862V49.07a3.447,3.447,0,0,1-3.448,3.448H4.448A3.447,3.447,0,0,1,1,49.07V12.862L1.862,12H50.137Z" transform="translate(0 -1.519)" fill="#eceff3"/>
            <path id="Union_1" data-name="Union 1" d="M29.946,10.344H0V3.451A3.448,3.448,0,0,1,3.448,0h43.1A3.451,3.451,0,0,1,50,3.451v6.893Z" transform="translate(1.001 0.999)" fill="#25afd9"/>
            <rect id="Rectangle_20368" data-name="Rectangle 20368" width="39.009" height="2" rx="1" transform="translate(6 31.996)" fill="#adbfc4"/>
            <rect id="Rectangle_20369" data-name="Rectangle 20369" width="39.009" height="2" rx="1" transform="translate(6 37.997)" fill="#adbfc4"/>
            <circle id="Ellipse_356" data-name="Ellipse 356" cx="1" cy="1" r="1" transform="translate(19.003 43.999)" fill="#adbfc4"/>
            <rect id="Rectangle_20370" data-name="Rectangle 20370" width="9" height="2" rx="1" transform="translate(25.005 43.999)" fill="#adbfc4"/>
            <path id="Path_92392" data-name="Path 92392" d="M2.965,1.645H.873V-8.509H2.965ZM8.691-1.891H4.765V-3.515H8.691Zm6.249-.523a2.545,2.545,0,0,1-1.841.774,2.722,2.722,0,0,1-2.155-.924,3.652,3.652,0,0,1-.809-2.493,3.89,3.89,0,0,1,.436-1.831,3.2,3.2,0,0,1,1.217-1.3,3.376,3.376,0,0,1,1.757-.464,3.229,3.229,0,0,1,1.785.5A3.3,3.3,0,0,1,16.544-6.7a5.183,5.183,0,0,1,.439,2.155V-3.8A5.873,5.873,0,0,1,15.721.188a4.772,4.772,0,0,1-3.578,1.548l-.5.007V.062l.446-.007Q14.724-.063,14.94-2.414Zm-1.346-.767a1.41,1.41,0,0,0,.84-.251,1.677,1.677,0,0,0,.534-.607v-.83a2.771,2.771,0,0,0-.391-1.59,1.212,1.212,0,0,0-1.046-.565,1.177,1.177,0,0,0-1,.554,2.358,2.358,0,0,0-.391,1.391,2.294,2.294,0,0,0,.38,1.363A1.238,1.238,0,0,0,13.594-3.181Z" transform="translate(16.644 25.734)" fill="#24455b"/>
          </g>
        </svg>            
      </span>
      <label>Update the form I-9
        <small>Initiated on 1/23/2024</small>
      </label>
    </div>
    <div class="update_actions">
      <button class="btn theme_btn">Update Form I-9</button>
    </div>
</div>
</template>
<script> 
    export default {
        components:{
            
        },
        
    }


</script>